(() => {
  const ROOT = '.pdp-drawers';
  const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  const DURATION = 560;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function panel(details) {
    return details.querySelector('.accordion__panel');
  }

  function setHeight(el, value) {
    el.style.height = value;
  }

  function openDetails(details) {
    const el = panel(details);
    if (!el) {
      details.setAttribute('open', '');
      return;
    }

    if (prefersReducedMotion()) {
      details.setAttribute('open', '');
      setHeight(el, 'auto');
      return;
    }

    details.setAttribute('open', '');
    setHeight(el, '0px');
    el.offsetHeight;
    setHeight(el, el.scrollHeight + 'px');

    window.setTimeout(function () {
      if (details.hasAttribute('open')) setHeight(el, 'auto');
    }, DURATION);
  }

  function closeDetails(details) {
    const el = panel(details);
    if (!el) {
      details.removeAttribute('open');
      return;
    }

    if (prefersReducedMotion()) {
      details.removeAttribute('open');
      setHeight(el, '0px');
      return;
    }

    setHeight(el, el.scrollHeight + 'px');
    el.offsetHeight;
    setHeight(el, '0px');

    window.setTimeout(function () {
      if (el.style.height === '0px') details.removeAttribute('open');
    }, DURATION);
  }

  function wire(root) {
    if (!root || root.dataset.drawersWired === '1') return;
    root.dataset.drawersWired = '1';

    root.querySelectorAll('details').forEach(function (details) {
      const el = panel(details);
      if (el) {
        el.style.transition = 'height ' + DURATION + 'ms ' + EASE;
        setHeight(el, details.hasAttribute('open') ? 'auto' : '0px');
      }

      const summary = details.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        if (details.hasAttribute('open')) closeDetails(details);
        else openDetails(details);
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
